import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function submitDocument({ ticket_id, document_type, form_value = {}, }){
    const params = {document_type, ...form_value};
    const submitDocumentResponse = await axios.post(`government/lhdn/ticket/${ticket_id}/submit_document`, params, { withCredentials : true, });
    return submitDocumentResponse?.data;
}

async function fetchSubmittedDocument(document_id){
    const documentResponse = await axios.get(`government/trans/document/${document_id}`, { withCredentials : true, });
    return documentResponse?.data;
}

// async function fetchDocumentByTicket(ticket_id){
//     const documentResponse = await axios.get(`government/trans/ticket/${ticket_id}/document`, { withCredentials : true, });
//     return documentResponse?.data;
// }

async function fetchDocumentLine(params){
    const documentLineResponse = await axios?.post(`government/trans/document_line/list`, params, { withCredentials : true, });
    return documentLineResponse?.data;
}

export default {
    submitDocument,
    fetchSubmittedDocument,
    fetchDocumentLine,
}